<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-top-transition"
    max-width="1100"
  >
    <div class="card-dialog">
      <button
        type="button"
        class="button-close"
        @click="closeDialog()"
      >
        <v-icon color="primary">
          mdi-close
        </v-icon>
      </button>

      <h1 class="title">
        {{ $t('components.related_offers_cart_dialog.title') }}
      </h1>

      <p class="subtitle">
        {{ $t('components.related_offers_cart_dialog.subtitle') }}
      </p>

      <div class="offers-table">
        <div class="offers-head">
          <span class="col col-material">
            {{ headLabel('material') }}
          </span>
          <span class="col col-mass">
            {{ headLabel('mass') }}
          </span>
          <span class="col col-operator">
            {{ headLabel('operator') }}
          </span>
          <span class="col col-state">
            {{ headLabel('state') }}
          </span>
          <span class="col col-credits">
            {{ headLabel('credits') }}
          </span>
          <span class="col col-value">
            {{ headLabel('unit_value') }}
          </span>
          <span class="col col-value">
            {{ headLabel('central_custody_fee_value') }}
          </span>
          <span class="col col-value">
            {{ headLabel('total_value') }}
          </span>
          <span class="col col-action" />
        </div>

        <ul class="offers-list">
          <li
            v-for="offer in getRelatedOffersForCart"
            :key="offer.id"
            class="offer-row"
          >
            <span class="col col-material">
              <component
                :is="getIconByMaterialType(mountMaterial(offer.material_type), false)"
              />
            </span>
            <span class="col col-mass">
              {{
                $t('components.card_credit_offered.table_credit_offereds.mass_quantity', {
                  amount: Number(offer.mass_quantity).toLocaleString('pt-BR'),
                })
              }}
            </span>
            <span class="col col-operator">
              {{ businessKindLabel(offer.business_kind) }}
            </span>
            <span class="col col-state">
              {{ offer.business_state }}
            </span>
            <span class="col col-credits">
              {{
                $t('components.card_credit_offered.table_credit_offereds.credits_quantity', {
                  amount: offer.credits_quantity,
                })
              }}
            </span>
            <span class="col col-value">
              {{ formatMoney(offer.unit_value_with_aditional) }}
            </span>
            <span class="col col-value">
              {{ formatMoney(offer.central_custody_fee_value) }}
            </span>
            <span class="col col-value total-value">
              {{ formatMoney(offer.total_value_with_aditional) }}
            </span>
            <span class="col col-action">
              <a
                class="view-offer-link"
                :href="offerHref(offer.id)"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ $t('components.related_offers_cart_dialog.view_offer') }}
              </a>
            </span>
          </li>
        </ul>
      </div>

      <div class="actions">
        <button
          type="button"
          class="primary-button"
          @click="addAll()"
        >
          {{ $t('components.related_offers_cart_dialog.add_all') }}
        </button>
        <button
          type="button"
          class="secondary-button"
          @click="closeDialog()"
        >
          {{ $t('components.related_offers_cart_dialog.add_none') }}
        </button>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import formatMoney from '@/mixins/formatMoney';
import getIconsByMaterialType from '@/mixins/getIconsOfMaterialType';

export default {
  name: 'RelatedOffersCartDialog',
  mixins: [formatMoney, getIconsByMaterialType],
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    ...mapGetters([
      'getRelatedOffersCartDialog',
      'getRelatedOffersForCart',
    ]),
  },
  watch: {
    getRelatedOffersCartDialog(value) {
      this.dialog = value;
    },
  },
  beforeDestroy() {
    this.closeDialog();
  },
  methods: {
    ...mapActions([
      'closeRelatedOffersCartDialog',
      'addAllRelatedOffersToCart',
    ]),
    closeDialog() {
      this.closeRelatedOffersCartDialog();
    },
    addAll() {
      this.addAllRelatedOffersToCart().then((result) => {
        if (result && result.success && result.redirectTo) {
          this.$router.push({ name: result.redirectTo });
        }
      });
    },
    offerHref(id) {
      return this.$router.resolve({ name: 'offered', params: { id } }).href;
    },
    headLabel(key) {
      return this.$t([
        'components.card_credit_offered.table_credit_offereds.head',
        key,
      ].join('.'));
    },
    businessKindLabel(businessKind) {
      const key = [
        'components.card_credit_offered.table_credit_offereds.businesses_kinds',
        businessKind,
      ].join('.');

      return this.$t(key);
    },
    mountMaterial(material) {
      if (material === 'Papel') return 'paper';
      if (material === 'Plástico') return 'plastic';
      if (material === 'Vidro') return 'glass';
      return 'metal';
    },
  },
};
</script>
<style lang="scss" scoped>
.card-dialog {
  padding: 40px;
  border-radius: 10px;
  background: $dialog_bank_account_background;
  display: flex;
  flex-direction: column;
  position: relative;
}

.button-close {
  position: absolute;
  top: 20px;
  right: 20px;
  background: transparent;
  border: 0;
  cursor: pointer;
}

.title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}

.subtitle {
  text-align: center;
  margin-bottom: 24px;
}

.offers-table {
  width: 100%;
  margin-bottom: 24px;
  overflow-x: auto;
}

.offers-head,
.offer-row {
  display: grid;
  grid-template-columns:
    72px
    minmax(70px, 0.8fr)
    130px
    56px
    minmax(90px, 1fr)
    minmax(90px, 1fr)
    minmax(80px, 0.9fr)
    minmax(90px, 1fr)
    minmax(90px, 1fr);
  gap: 8px;
  align-items: center;
}

.offers-head {
  padding: 0 16px 10px;
  color: $color_gray;
  font-size: 0.8125em;
  font-weight: 600;
}

.offers-list {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
}

.offer-row {
  background: $card_offer;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 12px;
  font-size: 0.875em;
  font-weight: 600;
  color: $color_dark;
}

.col {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-width: 0;
}

.col-operator {
  justify-content: center;
  text-align: center;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.total-value {
  color: $color_primary;
}

.view-offer-link {
  color: $color_primary;
  font-weight: bold;
  text-decoration: underline;
  white-space: nowrap;
}

.actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.primary-button,
.secondary-button {
  width: 100%;
  max-width: 420px;
  border-radius: 10px;
  font-weight: bold;
  font-size: 1.125em;
  padding: 18px 24px;
  cursor: pointer;
}

.primary-button {
  background: $color_primary;
  border: 2px solid $color_primary;
  color: $color_white;
}

.secondary-button {
  background: transparent;
  border: 2px solid $color_primary;
  color: $color_primary;
}
</style>
